import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_CHAUFFEUR_V2, UPDATE_CHAUFFEUR_V2_SUCCESS, UPDATE_CHAUFFEUR_V2_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* updateChauffeurV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/chauffeur/update`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPDATE_CHAUFFEUR_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_CHAUFFEUR_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_CHAUFFEUR_V2_ERROR, payload: error });
  }
}

export function* watchupdateChauffeurV2() {
  yield takeEvery(UPDATE_CHAUFFEUR_V2, updateChauffeurV2);
}

function* updateChauffeurV2Saga() {
  yield all([fork(watchupdateChauffeurV2)]);
}

export default updateChauffeurV2Saga;
